import { connect, MapStateToProps } from 'react-redux'
import { Props } from './ComparisonPdfModal'
import comparisonCarlineResultDataSelector
    from '../../../redux/selectors/comparison/comparisonCarlineResultDataSelector'
import comparisonDataSelector from '../../../redux/selectors/comparison/comparisonDataSelector'
import pdfRequestIsPendingSelector from '../../../redux/selectors/pending-request/pdfRequestIsPendingSelector'
import { createComparisonPdf } from '../../../redux/actions/app/comparisonPdf.actions'

type StateProps = Pick<
    Props,
    | 'resultData'
    | 'comparisonData'
    | 'requestIsPending'
>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    resultData: comparisonCarlineResultDataSelector(state),
    comparisonData: comparisonDataSelector(state),
    requestIsPending: pdfRequestIsPendingSelector(state),
})

type DispatchProps = Pick<Props, 'createComparisonPdf'>

const mapDispatchToProps: DispatchProps = {
    createComparisonPdf,
}

export default connect(mapStateToProps, mapDispatchToProps)
